import { TenantIncidentScreen } from "@src/features/patriot-tools";

export default TenantIncidentScreen;
